/**
 * Removes diacritical marks (accents) from a string using Unicode NFD normalization.
 * Example: "André Éric Hélène" → "Andre Eric Helene"
 */
export const stripAccents = (str: string): string => str.normalize('NFD').replace(/[̀-ͯ]/g, '');
